import TextLink from '../public/screens/partials/TextLink';

const LinkedTranslation = ({
	href = '', text = '', title = '', external, colorLink = 'text-oly-blue-dark', colorSpan = 'text-oly-gray-darkest',
}) => (
	<>
		{text.split(/(#u#.*?#u#)/).map((item) => (item.includes('#u#')
			? <TextLink key={item} href={href} text={item.replaceAll('#u#', '')} title={title} color={colorLink} external={external} />
			: <span key={item} className={`text-[0.875rem] ${colorSpan}`}>{item}</span>))}
	</>
);

export default LinkedTranslation;
